import { h } from 'preact';
import { Link } from 'preact-router/match';
import { useEffect, useMemo, useState } from 'preact/hooks';

import { useSignal, useSignalEffect } from '@preact/signals';
import Visibility from '../visibility';
import { GlobalState } from '../../states/global-state';
import Store from '../../stores/Store';
import { route } from 'preact-router';

const KycSeries = props => {
  const [kycIsActive, setKycIsActive] = useState(false);
  const [reviewIsActive, setReviewIsActive] = useState(false);

  const kycPercentage = useSignal('0%');
  const fatcaPercentage = useSignal('0%');
  const riskPercentage = useSignal('0%');

  const isLoaded = useSignal(false);
  const store = useMemo(() => new Store(), []);

  useSignalEffect(() => {
    const completeness = GlobalState.completeness.value;

    if (Object.keys(completeness).length) {
      isLoaded.value = true;

      setTimeout(() => {
        kycPercentage.value = `${completeness.kyc}%`;
        fatcaPercentage.value = `${completeness.fatca}%`;
        riskPercentage.value = `${completeness.riskProfile}%`;
      }, 100);
    }
  });

  useEffect(() => {
    props.path && props.path.includes('kyc') && setKycIsActive(true);
    props.path && props.path.includes('review') && setReviewIsActive(true);

    store.getCompleteness();

    /**
     * ensure that if the completeness is 100% it will redirect to review page.
     */
    const asy = setTimeout(() => {
      const currentPage = GlobalState.currentPage.peek();
      if (currentPage) {
        if (
          kycPercentage.value.includes('100') &&
          fatcaPercentage.value.includes('100') &&
          riskPercentage.value.includes('100') &&
          !currentPage.url.includes('review')
        ) {
          route('/review');
        }
      }
    }, 2000);
    return () => {
      clearTimeout(asy);
    };
  }, []);
  return (
    <nav class="nav nav-underline flex-column flex-sm-row">
      <Visibility condition={!reviewIsActive}>
        <li class="nav-item">
          <Link
            class="nav-link"
            href="/profile"
            style={(() => {
              if (isLoaded.value) {
                return { padding: '0px 10px 0px 10px' };
              }
            })()}
          >
            PROFILE
          </Link>
        </li>
      </Visibility>
      <li class="nav-item position-relative">
        <Visibility condition={isLoaded}>
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
            style={{
              background: `linear-gradient(90deg, green, ${kycPercentage}, red)`,
            }}
          >
            {kycPercentage}
          </span>
        </Visibility>

        <Link
          class={`nav-link ${kycIsActive ? 'active' : ''}`}
          style={(() => {
            if (isLoaded.value) {
              return { padding: '0px 50px 0px 10px' };
            }
          })()}
          activeClassName="active"
          href={reviewIsActive ? '/review/kyc' : '/kyc'}
        >
          KYC
        </Link>
      </li>
      <li class="nav-item position-relative">
        <Visibility condition={isLoaded}>
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
            style={{
              background: `linear-gradient(90deg, green, ${fatcaPercentage}, red)`,
            }}
          >
            {fatcaPercentage}
          </span>
        </Visibility>

        <Link
          class="nav-link"
          activeClassName="active"
          href={reviewIsActive ? '/review/fatca' : '/fatca'}
          style={(() => {
            if (isLoaded.value) {
              return { padding: '0px 50px 0px 10px' };
            }
          })()}
        >
          FATCA
        </Link>
      </li>
      <li class="nav-item position-relative">
        <Visibility condition={isLoaded}>
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
            style={{
              background: `linear-gradient(90deg, green, ${riskPercentage}, red)`,
            }}
          >
            {riskPercentage}
          </span>
        </Visibility>

        <Link
          class="nav-link"
          activeClassName="active"
          href={reviewIsActive ? '/review/riskprofile' : '/riskprofile'}
          style={(() => {
            if (isLoaded.value) {
              return { padding: '0px 10px 0px 10px' };
            }
          })()}
        >
          RISK PROFILE
        </Link>
      </li>
    </nav>
  );
};

export default KycSeries;
